import slugify from "slugify";
import { StaticImageData } from "next/image";

// hero images
import cloture_portaille_hero from "../../../assets/images/conceptions-entretien/cloture_et_protail.jpg";
import bassins_hero from "../../../assets/images/conceptions-entretien/bassin.jpg";
import protection_solaire_hero from "../../../assets/images/conceptions-entretien/protection_solaire.jpg";
import terrasses_hero from "../../../assets/images/conceptions-entretien/terrasses.jpg";
import acces_cheminement_hero from "../../../assets/images/conceptions-entretien/acces_et_cheminement.jpg";
import amenagement_paysagers_hero from "../../../assets/images/conceptions-entretien/amenagement_paysager.jpg";
import eclairage_hero from "../../../assets/images/conceptions-entretien/eclairage.jpg";

// card images
import cloture_portaille_card from "../../../assets/images/conceptions-entretien/card-images/cloture_et_protail.jpg";
import bassins_card from "../../../assets/images/conceptions-entretien/card-images/bassin.jpg";
import protection_solaire_card from "../../../assets/images/conceptions-entretien/card-images/protection_solaire.jpg";
import terrasses_card from "../../../assets/images/conceptions-entretien/card-images/terrasses.jpg";
import acces_cheminement_card from "../../../assets/images/conceptions-entretien/acces_et_cheminement.jpg";
import amenagement_paysagers_card from "../../../assets/images/conceptions-entretien/card-images/amenagement_paysager.jpg";
import eclairage_card from "../../../assets/images/conceptions-entretien/card-images/eclairage.jpg";

//logoplan
import cloture_portaille_plan from "../../../assets/images/conceptions-entretien/clotures.svg";
import bassins_plan from "../../../assets/images/conceptions-entretien/bassin.svg";
import protection_solaire_plan from "../../../assets/images/conceptions-entretien/protection-solaire.svg";
import terrasses_plan from "../../../assets/images/conceptions-entretien/terrasse.svg";
import acces_cheminement_plan from "../../../assets/images/conceptions-entretien/acces-cheminement.svg";
import amenagement_paysagers_plan from "../../../assets/images/conceptions-entretien/amenagement-paysager.svg";
import eclairage_plan from "../../../assets/images/conceptions-entretien/eclairage.svg";

export const steps = [
  {
    title: "Prise d'informations",
    text: "<p>A réception de votre demande et de vos photos, nous nous entretenons avec vous par téléphone afin de préciser votre projet et déterminer si nous sommes en mesure d&apos;y répondre. Cela permet notamment de ne pas vous faire déplacer pour rien (au cas où...) on ne sait jamais !</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
  {
    title: "La rencontre",
    text: "<p>Le rendez-vous en présentiel. En fonction de la typologie de la demande, nous venons directement chez vous ou nous prenons rendez-vous pour vous recevoir à l&apos;entreprise afin de découvrir notre jardin d&apos;exposition. Cela permet de sélectionner les matériaux “en vrai” et également d&apos; affiner le projet.</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
  {
    title: "La prise de mesure",
    text: "<p>Détermination de l&apos;emprise du chantier, le passage des réseaux, l&apos;altimétrie pour l&apos; écoulement des eaux...</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
  {
    title: "Le rendu",
    text: "<p>On se revoit au bureau si nécessaire pour présenter le dessin et vous remettre notre proposition chiffrée. </p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
];

export interface EntretienCreation {
  slug: string;
  title: string;
  dirDetailsImage: string;
  textsCard: string[];
  image: StaticImageData | string;
  textDetail: string;
  heroImage: StaticImageData | string;
  url: string;
  details: {
    items: {
      title: string;
      image: StaticImageData | string;
      text: string;
    }[];
    services: { url: string; label: string }[];
  };
  logoPlan: StaticImageData;
  metadescription?: string;
}

const mainDetailsImageDir = "/images/savoir-faire/conception";

export const creationData: EntretienCreation[] = [
  {
    title: "Clôtures & portails",
    textsCard: [
      "Intimité, sécurité ou élément décoratif, nous vous proposons une très large gamme de solutions !",
    ],
    image: cloture_portaille_card,
    textDetail: /* html */ `<p>Pratique ou esthétique, ils répondent autant à votre besoin de <span>délimiter une zone</span> qu&apos;<span>à créer une zone d&apos;intimité</span> pour vos soirée conviviales.</p>`,
    heroImage: cloture_portaille_hero,
    dirDetailsImage: "clotures-et-portails",
    logoPlan: cloture_portaille_plan,
    details: {
      items: [
        {
          title: "Portail aluminium",
          text: "<p>En deux vantaux ou coulissant, motorisé ou manuel la gamme est très large ! Demandez notre catalogue afin de vous faire une idée sur la question.</p>",
        },
        {
          title: "Clôture rigide",
          text: "<p>Résistante et aérée, elle permet de sécuriser tout en restant légère. Avec ou sans plaque béton, elle sait s&apos; adapter à quasiment tous les terrains.</p>",
        },
        {
          title: "Panneau aluminium décoratif",
          text: "<p>Pour donner du style à votre terrasse ou pour structurer un massif, on le retrouve même en insert dans d&apos;autres types de clôture.</p>",
        },
        {
          title: "Claustra en bois",
          text: "<p>Lames alternées, effet plein, ajouré, le choix est vaste ! En tout cas, du bois oui mais du bon qui dure et posé comme il se doit.</p>",
        },
        {
          title: "Lames en aluminum",
          text: "<p>Les lames profilées viennent se superposées pour atteindre la hauteur souhaitée. Nous pouvons y créer des effets visuels en jouant avec leur espacement ou leur orientation.</p>",
        },
        {
          title: "Gabion",
          text: "<p>Cette structure nous permet d&apos; apporter un côté minéral très design à la scène de jardin. Le principe ? Insérer de la roche entre deux panneaux rigides. </p>",
        },
        {
          title: "Panneaux barreaudé",
          text: "<p>Donnant du style tout en sécurisant votre propriété, la gamme  barreaudée saura vous charmer par sa robustesse et son élégance. </p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Bassins",
    textDetail: /* html */ `<p>Lieu de vie et de détente par excellence, laissez vous bercer par le doux bruit de l&apos;eau. <span>Moderne</span> ou <span>naturel</span>, chaque bassin saura s&apos;adapter au style qui vous est propre.</p>`,
    textsCard: ["Moderne ou plutôt naturel ?", " Choisissez votre style !"],
    image: bassins_card,
    heroImage: bassins_hero,
    dirDetailsImage: "bassin",
    logoPlan: bassins_plan,
    details: {
      items: [
        {
          title: "Structure maçonnée",
          text: "<p>Cette solution permet de réaliser des bassins aux formes rectilignes et épurées. Elles est particulièrement adaptée pour les projets “modernes”.</p>",
        },
        {
          title: "Revêtement EPMD",
          text: "<p>De forme beaucoup plus libre que pour une structure maçonnée, ce type de bassin est fait pour créer une zone de vie dans votre jardin !.</p>",
        },
        {
          title: "Jeu d'eau",
          text: "<p>Effet visuel et/ou doux bruit de l&apos;eau qui coule ? L&apos;écoulement de l&apos;eau peut avoir un effet hypnotique fascinant. Prêt à vous détendre ?</p>",
        },
        {
          title: "Filtration",
          text: "<p>Essentielle pour assurer la bonne circulation de l&apos;eau et limiter le développement des algues, elle se doit d&apos;être adaptée à la taille de votre bassin et à votre besoin.</p>",
        },
        {
          title: "Végétalisation",
          text: "<p>Fraicheur, phyto épuration, style, ambiance les bienfaits sont nombreux !</p>",
        },
        {
          title: "Eclairage",
          text: "<p>Touche finale, il sublimera l&apos;ensemble. </p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Protection solaire",
    textDetail: /* html */ `<p>Afin de profiter au maximum du jardin, <span>un coin d&apos;ombre</span> est toujours le bienvenu nécessaire. Pergola, voile d&apos;ombrage, végétation haute, nous sommes en mesure d&apos;y répondre et de l&apos;<span>adapter à votre jardin.</span></p>`,
    textsCard: [
      "Pergola bioclimatique, voile d&apos;ombrage, végétalisation... le tout c&apos;est d&apos; être à l&apos;ombre !",
    ],
    image: protection_solaire_card,
    heroImage: protection_solaire_hero,
    dirDetailsImage: "protection-solaire",
    logoPlan: protection_solaire_plan,
    details: {
      items: [
        {
          title: "Voile d'ombrage",
          text: `<p>Des formes sur mesures, des textures variées et des couleurs en grand nombre ... les possibilités sont infinies !
          Ce type de solution saura s&apos;adapter à votre jardin pour vous apporter de l&apos;ombre là où vous en avez l&apos;envie.</p>`,
        },
        {
          title: "Pergola bioclimatique",
          text: "<p>Structure en aluminium. Adossée, ou autoportante le choix est très large. Toiture imperméable et rétroéclairée pour les soirée qui se prolongent. Cette solution est personnalisable à souhait... qu&apos; attendez-vous ?</p>",
        },
        {
          title: "Végétalisation",
          text: "<p>Les solutions naturelles existent et permettent d&apos;allier ombre, fraicheur, abris pour les espèces naturelles, esthétisme, occultations et même des fruits si on le souhaite... Alors, on le plante quand cet arbre ?</p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Terrasses",
    textDetail: /* html */ `<p>Pour manger en famille, passer une soirée entre ami(e)s ou simplement profiter d&apos;un moment de détente, nos terrasses sont pensées pour s&apos;<span>adapter à tous vos besoins !</span> Nous saurons allier confort, design, et simplicité d&apos;entretien <span>pour que vous n&apos;ayez plus qu&apos;à en profiter !</span></p>`,
    textsCard: [
      "Bois, Céramique, béton... la liste est longue ! Et pourquoi pas un mélange ?",
    ],
    image: terrasses_card,
    heroImage: terrasses_hero,
    dirDetailsImage: "terrasses",
    logoPlan: terrasses_plan,
    details: {
      items: [
        {
          title: "Céramique",
          text: "<p>Matériau idéal pour vos espaces de vie, elle allie modernité, durabilité et simplicité d&apos;entretien. Le grand nombre de collections vous permet de leurs donner un style qui vous est propre !</p>",
        },
        {
          title: "Bois",
          text: "<p>Pin traité autoclave ou bois thermochauffé, nous vous proposons différentes essences et finitions pour un rendu totalement personnalisé. </p>",
        },
        {
          title: "Pierre naturelle",
          text: "<p>En grands ou petits formats, ce matériau naturel n&apos;a plus à faire ses preuves. Il saura vous charmer par sa variété de nuances, formes, couleurs, aspects... </p>",
        },
        {
          title: "Pavés & Dalles en Béton",
          text: "<p>Il existe une multitude de possibilités ! Effet brut, avec un revêtement en pierre reconstituée, aspect brique de sol.... Carré, rectangulaire, pose destructurée, format d&apos; un mètre par un mètre... la liste est longue ! </p>",
        },
        {
          title: "Pourquoi pas un mixte ?",
          text: "<p>Nous saurons vous proposer des projets totalement personnalisés en accord avec vos besoins et vos envies. Pourquoi pas une partie bois pour l&apos;espace détente et un espace en céramique pour le quotidien par exemple ?</p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Accès & cheminement",
    metadescription:
      "Optimisez vos accès et cheminements extérieurs avec Cockenpot Paysage : graviers, pavés, dalles et enrobés pour des allées esthétiques et durables",
    textDetail: /* html */ `<p>Essentiels au quotidien, ces surfaces se doivent d'être <span>fonctionnelles et durables</span>... et pourquoi pas drainantes...?</p>`,
    textsCard: [
      `Esthétique & fonctionnel, en pavés, enrobé ou graviers stabilisés... il n&apos; y a plus qu&apos; à faire son choix !`,
      "On vous montre ?",
    ],
    image: acces_cheminement_card,
    heroImage: acces_cheminement_hero,
    dirDetailsImage: "acces-et-cheminement",
    logoPlan: acces_cheminement_plan,
    details: {
      items: [
        {
          title: "Stabilisateur de graviers",
          text: "<p>Cette solution drainante est très bien adaptée pour les cheminements piétons ainsi que les allées véhicules. Les alvéoles en PEHD (polyéthylène haute densité), sauront résister aux intempéries et garder vos pieds au sec tout au long de l&apos;année. </p>",
        },
        {
          title: "Pavés & Dalles en Béton",
          text: "<p>Il existe une multitude de possibilités ! Effet brut, avec un revêtement en pierre reconstituée, aspect brique de sol.... Carré, rectangulaire, pose destructurée, format d&apos; un mètre par un mètre... la liste est longue ! </p>",
        },
        {
          title: "Pavés pierre naturelle",
          text: "<p>Pierre bleue, Grès, lisses, structurés, la pierre naturelle donnera un côté chic et pratique à vos allées !</p>",
        },
        {
          title: "Enrobé",
          text: "<p>Posé à chaud sur environ 4 - 5 cm d&apos; épaisseur, ce revêtement a un bon rapport qualité prix. Imperméable, il ne demande pas beaucoup d&apos;entretien. </p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Aménagements paysagers",
    textDetail: /* html*/ `<p>Un jardin sans chlorophylle ? Impensable !
    Nous <span>nous adaptons</span> à votre budget et à vos envies pour vous imaginer <span>des espaces végétalisés</span> tout en minimisant le besoin en entretien.
    En plus vous faites un geste pour la planète... Alors à vos marques, prêt ? Plantez !</p>`,
    textsCard: [
      `Coloré, occultant, gourmant, atypique, ludique... construisons votre jardin ensemble !`,
    ],
    image: amenagement_paysagers_card,
    heroImage: amenagement_paysagers_hero,
    dirDetailsImage: "amenagement-paysager",
    logoPlan: amenagement_paysagers_plan,
    details: {
      items: [
        {
          title: "Plantation",
          text: "<p>Coloré, odorant, touffu ou épuré, gourmand, nous pouvons totalement personnaliser et aménager votre espace extérieur pour en faire un véritable lieu de vie. </p>",
        },
        {
          title: "Ecran végétal",
          text: "<p>Etre tranquille chez soi tout en étant dans un écrin de verdure ? C&apos;est possible ! Les nombreuses espèce végétales au catalogue permettent de créer de véritables “murs” végétalisés. </p>",
        },
        {
          title: "Retenue de terre",
          text: "<p>Une différence de niveau entre votre terrain et celui du voisin ? Un terrain en pente ? Nous avons plusieurs solutions à vous proposer. Poutres en chêne massives, Le béton, enrochement...</p>",
        },
        {
          title: "Engazonnement",
          text: "<p>Espace de prédilection pour un bon moment de détente, nos mélanges s&apos; adaptent à toutes les configurations. </p>",
        },
        {
          title: "Gazon de placage",
          text: "<p>Le but ? Avoir une surface engazonnée sans attendre.</p><p>Le principe ? Installer chez vous des rouleaux de gazon cultivé en pleine terre.</p><p>Les avantages ? Rendu immédiat, un gazon dense dès le début...</p>",
        },
        {
          title: "Système d'arrosage",
          text: "<p>Très utile notamment pour les jeunes plantations, il permet de réduire la quantité d&apos;eau utilisée et le temps à passer à arroser. Il permet également un bien meilleur développement du végétal lors des périodes de sécheresse que nous connaissons. </p>",
        },
        {
          title: "Paillage",
          text: "<p>Végétal ou minéral, le paillage va pouvoir donner un côté graphique au jardin tout limitant la pousse des adventices. Il permet également, pour certains, de garder l&apos; humidité du sol et de servir d&apos;amendement naturel. </p>",
        },
        {
          title: "Borduration",
          text: "<p>En corten, en aluminium, en bois... elles permettent de délimiter les espaces et de vous faciliter l&apos;entretien.</p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Eclairage de jardin",
    textDetail: /* html */ `<p>Essentiels au quotidien, ces surfaces se doivent d'être fonctionnelles et durables... et pourquoi pas drainantes...?</p>`,
    textsCard: [`Sublimez votre jardin par des jeux de lumières !`],
    metadescription:
      "Mettez en lumière vos extérieurs avec l'éclairage de jardin de Cockenpot Paysage. Sécurité et esthétique pour des espaces sublimés de jour comme de nuit",
    image: eclairage_card,
    heroImage: eclairage_hero,
    dirDetailsImage: "eclairages",
    logoPlan: eclairage_plan,
    details: {
      items: [
        {
          title: "Mise en valeur",
          text: "<p>Un arbre majestueux, une topiaire, un massif de graminées, un hortensia... leur mise en valeur le soir vous permettra de profiter de votre jardin même la nuit !  Attention tout de même à ne pas trop déranger la faune locale. </p>",
        },
        {
          title: "Balisage ",
          text: "<p>Quoi de plus désagréable que de rentrer chez soit le soir et de ne pas voir où l&apos;on met les pieds ? Cet éclairage vous permettra d&apos; arriver jusqu&apos;à votre porte d&apos;entrée sans encombre !</p>",
        },
        {
          title: "D&apos;ambiance",
          text: "<p>Soirée entre amis ou plutôt au calme avec un bon livre, il ne manque plus qu&apos;un petit jeu de lumière pour ambiancer le jardin et parfaire le moment !</p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
].map((item) => ({
  ...item,
  slug: slugify(item.title, { lower: true, strict: true, trim: true }),
  url: `/conception/${slugify(item.title, {
    lower: true,
    strict: true,
    trim: true,
  })}`,
  details: {
    ...item.details,
    items: item.details.items.map((el, index) => ({
      ...el,
      image: `${mainDetailsImageDir}/${item.dirDetailsImage}/d${index + 1}.jpg`,
    })),
  },
}));
